import React from "react";
import * as ReactDOM from "react-dom/client";
import NewsletterServiceSDK from "../Storage/NewsletterServiceSDK";
import SubscriptionBox from "./SubscriptionBox";
const rootElement = document.getElementById("newsletters-subscription-box-root");
const newsletterService = new NewsletterServiceSDK(rootElement.dataset.api, window.newsletterAdapter);
const { lpauth } = window;
ReactDOM.createRoot(rootElement).render(React.createElement(React.StrictMode, null,
    React.createElement(SubscriptionBox, { newsletterService: newsletterService, lpauth: lpauth, slug: rootElement.dataset.slug, rootElement: rootElement })));
